import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../client';
import { useChatStore } from '../../store/chatStore';
import { useNotificationStore } from '../../store/notificationStore';
import type { ChatMessageResponse } from '../../types/chat';

export function useChatConfirm() {
  const { addMessage, setPendingConfirmation } = useChatStore();
  const { addNotification } = useNotificationStore();

  return useMutation({
    mutationFn: async (actionId: string) => {
      const { data } = await apiClient.post<ChatMessageResponse>(
        `/chat/confirm/${actionId}`
      );
      return data;
    },
    onSuccess: (data) => {
      addMessage({
        id: crypto.randomUUID(),
        type: 'action_result',
        content: data.content,
        timestamp: new Date(),
        platformCards: data.platform_cards,
      });
      setPendingConfirmation(null);
    },
    onError: (error: any) => {
      addNotification({
        message: error.response?.data?.detail || 'Failed to confirm action',
        type: 'error',
      });
    },
  });
}

export function useChatCancel() {
  const { addMessage, setPendingConfirmation } = useChatStore();

  return useMutation({
    mutationFn: async (actionId: string) => {
      const { data } = await apiClient.post<ChatMessageResponse>(
        `/chat/cancel/${actionId}`
      );
      return data;
    },
    onSuccess: (data) => {
      addMessage({
        id: crypto.randomUUID(),
        type: 'action_result',
        content: data.content,
        timestamp: new Date(),
        platformCards: data.platform_cards,
      });
      setPendingConfirmation(null);
    },
  });
}
